import { useMapStore } from "stores/map";

import {
  midstreamNavigatorActions,
  useMidstreamNavigatorContext
} from "../../midstream/midstream-navigator/context/MidstreamNavigatorContext";
import { FilterKey } from "../toolbar/midstream-navigator/FilterButton";
import { clearGeojsonSource } from "../utils/geojsonSource";
import { safeRemoveLayerAndSource } from "../utils/layerOperations";
import {
  HIGHLIGHTED_FACILITY,
  HIGHLIGHTED_NETWORK_FACILITIES,
  WELL_NETWORK_MAP
} from "../utils/networkLayerConstants";

interface UseClearWellToFacilityNetworkProps {
  mapbox?: mapboxgl.Map;
}

interface UseClearWellToFacilityNetworkReturn {
  clearWellToFacilityNetwork: () => void;
}

/**
 * Custom hook that encapsulates the "Clear Well To Facility Network" functionality
 * Used by both NetworkVisualizationOverlay and FilterButton for consistent network clearing
 */
export function useClearWellToFacilityNetwork({
  mapbox
}: UseClearWellToFacilityNetworkProps): UseClearWellToFacilityNetworkReturn {
  const clearNetworkDepthLegend = useMapStore((s) => s.clearNetworkDepthLegend);
  const setShowNetworkOptions = useMapStore((s) => s.setShowNetworkOptions);
  const clearWellNetworkMapRequest = useMapStore((s) => s.clearWellNetworkMapRequest);
  const [, midstreamDispatch] = useMidstreamNavigatorContext();

  const clearWellToFacilityNetwork = () => {
    // Clear Zustand map store state
    clearNetworkDepthLegend();
    setShowNetworkOptions(false);
    clearWellNetworkMapRequest();

    // Clear map layers and sources if mapbox is available
    if (mapbox) {
      clearGeojsonSource(mapbox, HIGHLIGHTED_FACILITY);
      clearGeojsonSource(mapbox, WELL_NETWORK_MAP);

      safeRemoveLayerAndSource(mapbox, HIGHLIGHTED_NETWORK_FACILITIES);
    }

    // Clear midstream navigator filter state when network map is closed
    midstreamDispatch(midstreamNavigatorActions.removeFilter(FilterKey.WellNetwork));
  };

  return {
    clearWellToFacilityNetwork
  };
}
